class QuickViewDrawer extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('close', () => {
        const drawerContent = this.querySelector('.quick-view__content');
        drawerContent.innerHTML = '';
        drawerContent.classList.remove('hide-cover');

        document.dispatchEvent(new CustomEvent('quickview:close'));
      });
    }
  }
  customElements.define('quick-view-drawer', QuickViewDrawer);

  class QuickViewButton extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', (event) => {
        if (event.target.closest('.card-quick-view') || event.target.closest('.product-slide-caption')) event.preventDefault()

        // Show loading spinner
        const card = this.closest('.card-container') || this.closest('.card');
        if (card) {
          // Product card: overlay on entire card
          card.classList.add('qv-card-loading');
          this._loadingEl = card;
        } else {
          // Other buttons (pick-by-stars etc): spinner on button
          const btn = this.querySelector('button') || this;
          btn.classList.add('qv-btn-loading');
          this._loadingEl = btn;
        }

        this.closest('body').classList.add('hidden', 'quick-view-open')
        const drawer = document.querySelector('quick-view-drawer');
        if (drawer) {
          drawer.querySelector('quick-view').setAttribute('data-product-url', `${this.dataset.productVariantUrl}`)
          drawer.querySelector('summary').click();
          document.dispatchEvent(new CustomEvent('quickview:open', {
            detail: {
              productUrl: this.dataset.productUrl
            }
          }));
        }
        else if (this.dataset.productUrl) {
          window.location = this.dataset.productUrl;
        }
      });

      // Remove loading spinner when quick view content loads or closes
      const removeLoading = () => {
        if (this._loadingEl) {
          this._loadingEl.classList.remove('qv-card-loading', 'qv-btn-loading');
          this._loadingEl = null;
        }
      };
      document.addEventListener('quickview:loaded', removeLoading);
      document.addEventListener('quickview:close', removeLoading);
      this.quickButton = this.querySelector('.quick') || this.closest('.quick')
      if(this.quickButton.closest('.card__extras')) {
        this.quickButton.addEventListener('focus', () => {
          this.quickButton.closest('.card__extras').style.bottom = '8px'
        })
        this.quickButton.addEventListener('blur', () => {
          this.quickButton.closest('.card__extras').style.bottom = '-54px'
        })
        this.quickButton.addEventListener('quickview:open', () => {
          this.quickButton.closest('.card__extras').style.bottom = '-54px'
        })
      }
    }
  }
  customElements.define('quick-view-button', QuickViewButton);

  class QuickView extends HTMLElement {
    constructor() {
      super();
      this.overlay = document.querySelector('body > .overlay')
      this.quickModal = this.querySelector('.popup-wrapper')
      this.closeButton = this.querySelector('.button-close')
      this.addEventListener('click', (event) => {
        if (!event.target.closest('.popup-wrapper') || event.target.closest('.button-close')) this.closeQuickView()
      })
      document.addEventListener('keyup', (event) => {
        if (event.code && event.code.toUpperCase() === 'ESCAPE' && this.querySelector('.popup-wrapper.open')) this.closeQuickView()
      })
    }

    connectedCallback() {
      new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
    }

    handleIntersection(entries, _observer) {
      if (!entries[0].isIntersecting) return;
      const selector = '.quick-view__content';
      const drawerContent = this.querySelector(selector);
      this.productUrl = this.dataset.productUrl
      this.sectionUrl = `${this.productUrl}&view=quick-view`;

      fetch(this.sectionUrl)
        .then(response => response.text())
        .then(responseText => {
          setTimeout(() => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector(selector);
            this.setInnerHTML(drawerContent, productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            // Initialize mobile bottom sheet swipe-to-dismiss
            this.initMobileSwipe();
          }, 1);

          document.body.classList.add('quick-view-load')

          setTimeout(() => {
            drawerContent.classList.add('hide-cover');

            document.dispatchEvent(new CustomEvent('quickview:loaded', {
              detail: {
                productUrl: this.dataset.productUrl
              }
            }));
          }, 1);
        })
        .catch(e => {
          console.error(e);
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        this.overlay.classList.add('open')
      });
    }

    initMobileSwipe() {
      if (window.innerWidth > 920) return;

      const popupWrapper = this.querySelector('.popup-wrapper__quick-view');
      if (!popupWrapper) return;

      let startY = 0;
      let currentY = 0;
      let isDragging = false;

      const onTouchStart = (e) => {
        const scrollArea = popupWrapper.querySelector('.scroll-area');
        // Only allow swipe from near the top or when scroll is at top
        if (scrollArea && scrollArea.scrollTop > 0) return;
        startY = e.touches[0].clientY;
        isDragging = true;
        popupWrapper.style.transition = 'none';
      };

      const onTouchMove = (e) => {
        if (!isDragging) return;
        currentY = e.touches[0].clientY;
        const diff = currentY - startY;
        if (diff > 0) {
          popupWrapper.style.transform = `translateY(${diff}px)`;
          e.preventDefault();
        }
      };

      const onTouchEnd = () => {
        if (!isDragging) return;
        isDragging = false;
        const diff = currentY - startY;
        popupWrapper.style.transition = 'transform 0.3s ease';
        if (diff > 100) {
          popupWrapper.style.transform = 'translateY(100%)';
          setTimeout(() => this.closeQuickView(), 300);
        } else {
          popupWrapper.style.transform = 'translateY(0)';
        }
      };

      popupWrapper.addEventListener('touchstart', onTouchStart, { passive: true });
      popupWrapper.addEventListener('touchmove', onTouchMove, { passive: false });
      popupWrapper.addEventListener('touchend', onTouchEnd, { passive: true });
    }

    closeQuickView() {
      const drawerContent = this.querySelector('.quick-view__content');
      drawerContent.innerHTML = '';
      drawerContent.classList.remove('hide-cover');
      this.closest('body').classList.remove('hidden', 'quick-view-open', 'quick-view-load')
      document.dispatchEvent(new CustomEvent('body:visible'));
      document.dispatchEvent(new CustomEvent('quickview:close'));
      this.closest('details').removeAttribute('open')
      this.overlay.classList.remove('open')
      // Restore PDP buy buttons that may be stuck in loading state
      document.querySelectorAll('.main-product:not(.popup-wrapper__quick-view) .product-form__submit.loading').forEach(btn => {
        btn.classList.remove('loading');
        const spinner = btn.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.add('hidden');
      });
    }
  }
  customElements.define('quick-view', QuickView);
